import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { organizationActions, work_spaceActions } from "../actions";

function useEditWorkspacePopupHook() {
    const dispatch = useDispatch();
    const { selected_organization } = useSelector(state => state.sidebar);
    const [editWorkspacePopup, setEditWorkspacePopup] = useState({
        show: false,
        id: null
    });

    const handleCloseWorkspaceEditForm = () => {
        dispatch(organizationActions.getWorkspaces(selected_organization));
        setEditWorkspacePopup({ show: false, id: null });
    }

    const handleEditWorkspaceShowForm = (id) => {
        dispatch(work_spaceActions.editWorkSpace(id, setEditWorkspacePopup));
    }

    return {
        editWorkspacePopup,
        handleEditWorkspaceShowForm,
        handleCloseWorkspaceEditForm
    }
}

export default useEditWorkspacePopupHook;